import { render, staticRenderFns } from "./AppealFile.vue?vue&type=template&id=6755250c&scoped=true&"
import script from "./AppealFile.vue?vue&type=script&lang=js&"
export * from "./AppealFile.vue?vue&type=script&lang=js&"
import style0 from "./AppealFile.vue?vue&type=style&index=0&id=6755250c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6755250c",
  null
  
)

export default component.exports